import { render, staticRenderFns } from "./invalid-details.vue?vue&type=template&id=3c1f68aa&"
import script from "./invalid-details.vue?vue&type=script&lang=js&"
export * from "./invalid-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports